import { render, staticRenderFns } from "./myBag.vue?vue&type=template&id=48667b7d&scoped=true&"
import script from "./myBag.vue?vue&type=script&lang=js&"
export * from "./myBag.vue?vue&type=script&lang=js&"
import style0 from "./myBag.vue?vue&type=style&index=0&id=48667b7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48667b7d",
  null
  
)

export default component.exports